import React from 'react';
import { useField, FieldConfig } from 'formik';
import { FormControl, TextField, TextFieldProps } from '@mui/material';
import { CustomFieldLabel } from '../CustomFieldLabel/CustomFieldLabel';
import { FieldError } from '../FieldError/FieldError';

interface IFieldInputProps extends FieldConfig {
  label?: string;
  required?: boolean;
  height?: any;
}

export function CustomFieldText({ name, label, height, required, ...props }: IFieldInputProps & TextFieldProps) {
  const [field, meta] = useField(name);

  return (
    <FormControl className="field-container" fullWidth={props.fullWidth}>
      {label && <CustomFieldLabel required={required}>{label}</CustomFieldLabel>}
      <TextField
        {...props}
        {...field}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          height: "50px",
          gap: 2,
          alignSelf: "stretch",
          border: "none",
          borderRadius: "12px",
          backgroundColor: "var(--Base-24, #F4F4F4)",

          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },

          "& .MuiInputBase-input::placeholder": {
            color: "var(--Base-300, #B0B0B0)",
            fontFamily: "CircularStd",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 450,
            lineHeight: "normal",
          },

          "& .MuiInputBase-input": {
            color: "var(--Base-1000, #000)",
            fontFamily: "CircularStd",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
          },

          "& .MuiInputBase-input:focus": {
            outline: "none",
            boxShadow: "none",
            border: "none",
          },

          "& .MuiInputBase-input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0px 1000px var(--Base-24, #F4F4F4) inset !important",
            backgroundColor: "var(--Base-24, #F4F4F4) !important",
            color: "var(--Base-1000, #000) !important",
            border: "none !important",
            transition: "background-color 5000s ease-in-out 0s",
          },
        }}
      />
      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </FormControl>
  );
}

CustomFieldText.defaultProps = {
  label: '',
  required: false,
};
